/* eslint-disable no-unused-vars */
import qs from "qs";
import swal from "sweetalert2";
import React, { useEffect, useState } from "react";
import CS from "../../../services/commonService";
import BreadCrumbs from "../../common/breadcrumbs";
import Modal from "../../common/Modal";
import SearchBox from "../../common/searchBox";
import AddUpdate from "./addUpdate";
import {
	useGetFaqs,
	useUpdateFaq,
	useDeleteFaq,
	useGetFaqCategories,
} from "../../../queryHooks";
import SingleStatusToggle from "../../common/singleStatusToggle";
import Icon from "../../icons/index";
import ReactTooltip from "react-tooltip";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import Table from "../../common/table";
import { ROLES_CONFIG } from "../../../config/configs";
import { useStore } from "../../../zustand/store";
import { pageToLoadOnDelete } from "../../../helpers";
import { useLocation, useNavigate } from "react-router";
import { URL } from "../../../constants/URL";
//	Pre-defined values
const columnKey = "faqsListing";
//	Component starts
const Categories = () => {
	const location = useLocation();
	const navigate = useNavigate();
	//	State values
	const setLoading = useStore((state) => state.setLoading);
	const [topicFor, setTopicFor] = useState(ROLES_CONFIG.RESTAURANT);
	const [tabChangeCounter, setTabChangeCounter] = useState(0);
	const [category, setCategory] = useState({});
	const [faqCategories, setFaqCategories] = useState([]);
	const [open, setOpen] = useState(false);
	const [tableData, setTableData] = useState();
	const [pageNow, setPageNow] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [faqPayload, setFaqPayload] = useState({
		pagination: true,
		items_per_page: itemsPerPage,
		page: pageNow,
		filter: { ["faq_categories.role_id"]: ROLES_CONFIG.RESTAURANT },
	});

	useEffect(() => {
		switch (location.pathname) {
			case URL.faqsUser:
				setTopicFor(ROLES_CONFIG.USER);
				break;
			case URL.faqsRestaurant:
				setTopicFor(ROLES_CONFIG.RESTAURANT);
				break;
			default:
				setTopicFor(ROLES_CONFIG.RESTAURANT);
				break;
		}
	}, [location.pathname]);

	const {
		data: dataGetFaqs,
		isLoading,
		refetch,
	} = useGetFaqs(qs.stringify(faqPayload));

	useEffect(() => {
		if (dataGetFaqs && dataGetFaqs.status === "success") {
			let respData = dataGetFaqs.data;
			respData.page = pageNow;
			respData.items_per_page = itemsPerPage;
			setTableData(respData);
		}
	}, [dataGetFaqs]);

	const { data: dataGetFaqCategory } = useGetFaqCategories(
		qs.stringify({
			filter: { ["categories.role_id"]: topicFor, ["categories.is_active"]: 1 },
		})
	);

	useEffect(() => {
		if (dataGetFaqCategory && dataGetFaqCategory.data?.records) {
			let _faqCategories = [];
			dataGetFaqCategory.data.records.forEach((element) => {
				_faqCategories.push({
					label: element.name,
					value: element.id,
				});
			});
			setFaqCategories(_faqCategories);
		} else {
			setFaqCategories([]);
		}
	}, [dataGetFaqCategory]);

	const {
		mutateAsync: updateFaq,
		error: errorUpdateFaq,
		data: dataUpdateFaq,
	} = useUpdateFaq();

	useEffect(() => {
		if (dataUpdateFaq) {
			setLoading(false);
			if (dataUpdateFaq.status === "success") {
				CS.showSuccessMessage("Status updated successfully");
				refetch();
			} else if (dataUpdateFaq.status === "fail") {
				CS.showErrorMessage(dataUpdateFaq.message);
			}
		}
	}, [dataUpdateFaq]);

	useEffect(() => {
		if (errorUpdateFaq) {
			setLoading(false);
			CS.showErrorMessage(errorUpdateFaq.response?.data?.message);
		}
	}, [errorUpdateFaq]);

	const {
		mutateAsync: deleteFaq,
		error: errorDeleteFaq,
		data: dataDeleteFaq,
	} = useDeleteFaq();

	useEffect(() => {
		if (dataDeleteFaq) {
			setLoading(false);
			if (dataDeleteFaq.status === "success") {
				let _page = pageToLoadOnDelete(
					tableData?.total_items,
					1,
					pageNow,
					itemsPerPage
				);
				if (_page === pageNow) refetch();
				setPageNow(_page);
				setFaqPayload({ ...faqPayload, page: _page });
				CS.showSuccessMessage(dataDeleteFaq.message);
			} else if (dataDeleteFaq.status === "fail") {
				CS.showErrorMessage(dataDeleteFaq.message);
			}
		}
	}, [dataDeleteFaq]);

	useEffect(() => {
		if (errorDeleteFaq) {
			setLoading(false);
			CS.showErrorMessage(errorDeleteFaq.response?.data?.message);
		}
	}, [errorDeleteFaq]);

	const closeModal = () => {
		setCategory({});
		setOpen(false);
		refetch();
	};

	const handleChangeTab = (tabFor) => {
		setTabChangeCounter((count) => count + 1);
		setTopicFor(tabFor);
		switch (tabFor) {
			case ROLES_CONFIG.USER:
				navigate(URL.faqsUser);
				break;
			case ROLES_CONFIG.RESTAURANT:
				navigate(URL.faqsRestaurant);
				break;
			default:
				navigate(URL.faqsRestaurant);
				break;
		}
		setFaqPayload({
			pagination: true,
			items_per_page: itemsPerPage,
			page: pageNow,
			filter: { ["faq_categories.role_id"]: tabFor },
			search: "",
			role_id: tabFor,
		});
	};

	const columns = [
		{
			label: "Category Name",
			type: "string",
			sort: true,
			path: "category_name",
			alias: "faq_categories.name",
			aliasFilter: "faq_categories.id",
			filterOptions: faqCategories,
		},
		{
			label: "FAQ Question",
			type: "string",
			sort: true,
			path: "question",
			alias: "faqs.question",
		},
		{
			label: "FAQ Answer",
			type: "string",
			sort: true,
			path: "answer",
			alias: "faqs.answer",
		},
		{
			label: "Created On",
			type: "date",
			sort: true,
			path: "created_at",
			alias: "faqs.created_at",
			filterDate: true,
			content: (item) => getCurrentTimezoneDate(item.created_at, true),
		},
		{
			label: "Status",
			type: "boolean",
			aliasFilter: "faqs.is_active",
			filterOptions: [
				{ value: 1, label: "Active" },
				{ value: 0, label: "Inactive" },
			],
			content: (item) => (
				<SingleStatusToggle
					_id={item.id}
					status={item.is_active}
					onToggleChange={() => {
						updateFaq({
							id: item.id,
							is_active: item.is_active === 0 ? 1 : 0,
						});
						setLoading(true);
					}}
					htmlFor={item.id}
				/>
			),
		},
		{
			label: "Action",
			type: "boolean",
			content: (item) => (
				<>
					<Icon
						type="edit"
						data-tip
						data-for="edit"
						onClick={() => {
							setOpen(true);
							setCategory(item);
						}}
					/>
					<ReactTooltip id="edit" place="top" effect="solid">
						Edit
					</ReactTooltip>
					<Icon
						type="delete"
						data-tip
						data-for="delete"
						onClick={() =>
							swal
								.fire({
									title: "Are you sure you want to delete?",

									icon: "warning",
									showCancelButton: true,
									confirmButtonColor: "#3085d6",
									cancelButtonColor: "#d33",
									confirmButtonText: "Yes, delete it!",
								})
								.then((result) => {
									if (result.isConfirmed) {
										deleteFaq(item.id);
										setLoading(true);
									}
								})
						}
					/>
					<ReactTooltip id="delete" place="top" effect="solid">
						Delete
					</ReactTooltip>
				</>
			),
		},
	];

	return (
		<>
			<BreadCrumbs title="FAQs Management" data={[{ label: "FAQ" }]} />
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="left-buttons d-flex border-bottom">
							<button
								style={{ marginRight: "10px" }}
								className={
									topicFor == ROLES_CONFIG.RESTAURANT
										? "btn glow-primary btn-primary"
										: "btn btn-default minW-md-0 btn-bg-white"
								}
								onClick={() => handleChangeTab(ROLES_CONFIG.RESTAURANT)}
							>
								Restaurant
							</button>
							<button
								className={
									topicFor == ROLES_CONFIG.USER
										? "btn glow-primary btn-primary"
										: "btn btn-default minW-md-0 btn-bg-white"
								}
								onClick={() => handleChangeTab(ROLES_CONFIG.USER)}
							>
								User
							</button>
						</div>
						<div className="grid-content">
							<div className="user-listing-filterOptions mb-2 mt-3 d-block">
								<div className="row mb-2">
									<div className="col-sm-8 mb-2 position-static">
										<div className="left-buttons d-flex">
											<SearchBox
												columnKey={columnKey}
												search={(value) => {
													setPageNow(1);
													setFaqPayload({
														...faqPayload,
														search: {
															"faq_categories.name":
																!value && value === "" ? undefined : value,
															"faqs.question":
																!value && value === "" ? undefined : value,
															"faqs.answer":
																!value && value === "" ? undefined : value,
														},
														page: 1,
													});
												}}
											/>
										</div>
									</div>
									<div className="col-sm-4">
										<div className="right-buttons d-flex justify-content-end">
											<button
												onClick={() => setOpen(true)}
												id="addNewCategory"
												type="button"
												className="btn glow-primary btn-primary"
											>
												<i className="bx bx-user-plus d-lg-none" />
												<span className="d-none d-sm-none d-lg-inline-block">
													Add FAQ
												</span>
											</button>
										</div>
									</div>
								</div>
							</div>
							<Modal open={open} onCloseModal={closeModal}>
								<AddUpdate
									category={category}
									columnKey={columnKey}
									onCloseModal={closeModal}
									faqCategories={faqCategories}
								/>
							</Modal>
							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								sortCol={(obj) => {
									setPageNow(1);
									setFaqPayload({
										...faqPayload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setFaqPayload({ ...faqPayload, page });
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setFaqPayload({
										...faqPayload,
										items_per_page,
										page: 1,
									});
								}}
								loading={isLoading}
								filterValue={async (obj) => {
									if (obj.filter === null) {
										const resp = await CS.filterData(faqPayload.filter, obj);
										setPageNow(1);
										setFaqPayload({
											...faqPayload,
											filter: resp,
											page: 1,
										});
									} else {
										setPageNow(1);
										setFaqPayload({
											...faqPayload,
											filter: {
												...faqPayload.filter,
												[obj.alias]: obj.filter,
											},
											page: 1,
										});
									}
								}}
								filterDate={(dates) => {
									setPageNow(1);
									setFaqPayload({
										...faqPayload,
										filter_date: dates && {
											...faqPayload?.filter_date,
											[dates.alias]: String(dates.filter),
										},
										page: 1,
									});
								}}
								tabChangeCounter={tabChangeCounter}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Categories;
